import { Component, OnInit } from '@angular/core';
import { GeneralExerciseComponent } from '../../General/g-exercise.component';
import { ActivatedRoute } from '@angular/router';
import { TopicService } from '../topic.service';
import { MessageService } from '../../shared/message.service';
import { morseCode, nodes, edges, morseDecode } from '../../../assets/morse';
import * as shape from 'd3-shape';

@Component({
  selector: 'app-example',
  templateUrl: './example.component.html',
  styleUrls: ['./example.component.css']
})
export class ExampleComponent extends GeneralExerciseComponent {

  standardPage: string = 'none';

  
  view: any[] = [600, 300];
  fitContainer: boolean = true;
  curve = shape.curveLinear;
  nodes = nodes;
  edges = edges;
  morseCode = morseCode;
  morseDecode = morseDecode;


  constructor(protected activatedRoute: ActivatedRoute, protected topicService: TopicService, protected messageService: MessageService) {
    super(activatedRoute,topicService, messageService);
  }

  setTypeSpecificsFromConfiguration(){
    this.standardPage = this.configuration.typespecifics.standardPage;
  }
  
  setInfoFromState(){
    super.setInfoFromState();
    this.state.solved = true;
    this.solved = true;
    this.saveState();
  }

  setTypeSpecificsFromState(){

  }

  checkSolution(){}
  computeState(){}
  evaluate():number[]{return [1,1];}


}
